import React, { useState, useEffect, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { rfiInboxListStyle } from "../../../styles/jss/components/RFI/rfiInboxListStyle";

import Typography from "@material-ui/core/Typography";
import MuiAccordion from "@material-ui/core/Accordion";
import MuiAccordionSummary from "@material-ui/core/AccordionSummary";
import MuiAccordionDetails from "@material-ui/core/AccordionDetails";
import RFIInbox from "./RFIInbox";

import {
  oceanBlueColor,
  grayColor,
  blackColor,
} from "../../../styles/jss/cmsMainStyle";

const useStyles = makeStyles((theme) => rfiInboxListStyle(theme));
const InboxTypography = withStyles({
  root: {
    fontSize: 20,
    fontWeight: 600,
    color: blackColor,
  },
})(Typography);

const Accordion = withStyles({
  root: {
    border: "1px solid rgba(0, 0, 0, .125)",
    boxShadow: "none",
    "&:not(:last-child)": {
      borderBottom: 0,
    },
    "&:before": {
      display: "none",
    },
    "&$expanded": {
      margin: "auto",
    },
  },
  expanded: {},
})(MuiAccordion);

const AccordionSummary = withStyles({
  root: {
    backgroundColor: "rgba(0, 0, 0, .03)",
    borderBottom: "1px solid rgba(0, 0, 0, .125)",
    marginBottom: -1,
    minHeight: 56,
    "&$expanded": {
      minHeight: 56,
      backgroundColor: oceanBlueColor[4],
    },
  },
  content: {
    "&$expanded": {
      margin: "12px 0",
    },
  },
  expanded: {},
})(MuiAccordionSummary);

const AccordionDetails = withStyles((theme) => ({
  root: {
    padding: theme.spacing(1),
    height: "100%",
    // cursor: "pointer"
  },
}))(MuiAccordionDetails);

const RFIInboxList = (props) => {
  const [p1Expanded, setp1Expanded] = useState(false);
  const [p2Expanded, setp2Expanded] = useState(true);
  const classes = useStyles();
  const store = require("store");
  const dispatch = useDispatch();
  const { buildAlert } = props;
  const handleP1MenuChange = () => {
    setp1Expanded((current) => !current);
  };
  const handleP2MenuChange = () => {
    setp2Expanded((current) => !current);
  };
  const userCategoryCode = store.get("user_category_code") || "";

  const showDraftRfiBox =
    userCategoryCode === "SUPPLIER" ||
    userCategoryCode === "SUBCON" ||
    userCategoryCode === "SANFIELD";
  const showRfiBox =
    userCategoryCode === "CONSULTANT" || userCategoryCode === "SANFIELD";

  return (
    <Fragment>
      <div className={classes.root}>
        {showDraftRfiBox && (
          <Accordion square expanded={p1Expanded} onChange={handleP1MenuChange}>
            <AccordionSummary
              aria-controls="panel1d-content"
              id="panel1d-header"
            >
              <InboxTypography>Draft RFI Box</InboxTypography>
            </AccordionSummary>
            <div className={classes.rfiList}>
              <AccordionDetails>
                <RFIInbox is_draft="Y" buildAlert={buildAlert} />
              </AccordionDetails>
            </div>
          </Accordion>
        )}
        {showRfiBox && (
          <Accordion square expanded={p2Expanded} onChange={handleP2MenuChange}>
            <AccordionSummary
              aria-controls="panel21d-content"
              id="pane21d-header"
            >
              <InboxTypography>RFI Box</InboxTypography>
            </AccordionSummary>
            <div className={classes.rfiList}>
              <AccordionDetails>
                <RFIInbox is_draft="N" buildAlert={buildAlert} />
              </AccordionDetails>
            </div>
          </Accordion>
        )}
      </div>
    </Fragment>
  );
};

export default RFIInboxList;
